import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { TokenInvalidoError } from '../errors/TokenInvalidoError';
import { TurnoYaCalificadoError } from '../errors/TurnoYaCalificadoError';
import { obtenerCalificacionTurno, enviarCalificacionTurno } from '../services';
import { ESTADO_PAGINA } from '../constants/calificacionConstants';

const useCalificarAtencion = () => {
  const { token } = useParams();

  // Estado
  const [estado, setEstado] = useState(ESTADO_PAGINA.CARGANDO);
  const [turno, setTurno] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  // Métodos
  const cargarEstado = useCallback(async () => {
    setEstado(ESTADO_PAGINA.CARGANDO);
    try {
      const data = await obtenerCalificacionTurno(token);
      setTurno(data);
      setEstado(data.yaCalificado ? ESTADO_PAGINA.CALIFICADO : ESTADO_PAGINA.PENDIENTE);
    } catch (err) {
      setEstado(err instanceof TokenInvalidoError ? ESTADO_PAGINA.INVALIDO : ESTADO_PAGINA.ERROR);
    }
  }, [token]);

  useEffect(() => {
    cargarEstado();
  }, [cargarEstado]);

  const enviarCalificacion = useCallback(
    async (valoracion, valoracionObservacion) => {
      setIsSubmitting(true);
      setSubmitError(null);
      try {
        const data = await enviarCalificacionTurno(token, { valoracion, valoracionObservacion });
        setTurno(data);
        setEstado(ESTADO_PAGINA.CALIFICADO);
      } catch (err) {
        if (err instanceof TurnoYaCalificadoError) {
          // Alguien ya calificó este turno desde otra pestaña/dispositivo: traemos
          // el estado real (con las estrellas/comentario ya cargados) en vez de
          // tratarlo como un error técnico.
          await cargarEstado();
        } else if (err instanceof TokenInvalidoError) {
          setEstado(ESTADO_PAGINA.INVALIDO);
        } else {
          setSubmitError(err.message);
        }
      } finally {
        setIsSubmitting(false);
      }
    },
    [token, cargarEstado],
  );

  return {
    estado,
    turno,
    isSubmitting,
    submitError,
    enviarCalificacion,
    reintentar: cargarEstado,
  };
};

export default useCalificarAtencion;
